// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"f331b2dd","296":"b1bb1627","467":"6b3bf29b","793":"d31583db","838":"d10a6c01"}[chunkId] + ".chunk.js";
};